/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from 'react';
import ShellHeader from '@exc/shell/src/ShellHeader';

const AlertsContainer = React.lazy(() => import('@exc/pulse-ui/lib/pulse/components/alerts/AlertsContainer'));
const SearchWidget = React.lazy(() => import('@exc/search'));
const ShellLanguagePicker = React.lazy(() => import('@exc/shell/src/ShellLanguagePicker'));
const ShellSideNav = React.lazy(() => import('@exc/shell/src/ShellSideNav'));

export {
  AlertsContainer,
  SearchWidget,
  ShellHeader,
  ShellLanguagePicker,
  ShellSideNav
};
